import { connect } from "react-redux";
import { Dispatch } from "redux";
import IAppState from "../../redux/types/IAppState";
import AnalyticsPage from "./AnalyticsPage";
import { getUserCRMValuesThunk } from "../../redux/thunks/AccountThunks";
import { getMemberStatementPowerBiEmbedThunk, getPowerBIConfigurationThunk } from "../../redux/thunks/MembersPortalThunks";

export default connect(
    (state: IAppState) => ({
        currentUserGuid: state.account.currentUserGuid,
        currentUserNameNumber: state.account.currentUserNameNumber,
        powerBIEmbedParams: state.membersPortal.powerBIEmbedParams,
        powerBIConfiguration: state.membersPortal.powerBIAnalyticsConfig,
        statementsAnalyticsPageData: state.membersPortal.componentData.MemberStatementAnalyticsPage,
    }),
    (dispatch: Dispatch) => ({
        dispatch, 
        getUserCRMValues: () => dispatch<any>(getUserCRMValuesThunk()),
        getPowerBIConfiguration: () => dispatch<any>(getPowerBIConfigurationThunk()),
        getPowerBiEmbed: (reportId: string, queryParameter: string) => dispatch<any>(getMemberStatementPowerBiEmbedThunk(reportId, queryParameter))
    })
)(AnalyticsPage);